// Slot definitions and German labels.
// Colors cycle every 12 slots: slots 1/13/25 share color 1, 2/14/26 share color 2 and so on.
// The slot number remains the unique identifier; the color is only a visual aid.
const BASE_SLOT_COLORS = [
  { label: "Grün",       color: "#22C55E" },
  { label: "Lime",       color: "#84CC16" },
  { label: "Gelb",       color: "#FACC15" },
  { label: "Gold",       color: "#F59E0B" },
  { label: "Orange",     color: "#F97316" },
  { label: "Rot",        color: "#EF4444" },
  { label: "Dunkelblau", color: "#1E40AF" },
  { label: "Blau",       color: "#3B82F6" },
  { label: "Hellblau",   color: "#0EA5E9" },
  { label: "Türkis",     color: "#14B8A6" },
  { label: "Violett",    color: "#8B5CF6" },
  { label: "Magenta",    color: "#D946EF" },
];

export const TOTAL_SLOTS = 36;

// Full 36-slot definition. `colorIndex` (0..11) identifies the shared color
// bucket used by the compact legend to group slots {n, n+12, n+24}.
export const SLOTS = Array.from({ length: TOTAL_SLOTS }, (_, i) => {
  const base = BASE_SLOT_COLORS[i % BASE_SLOT_COLORS.length];
  return { n: i + 1, label: base.label, color: base.color, colorIndex: i % BASE_SLOT_COLORS.length };
});

// Grouped view used by the sidebar legend: 12 colored rows, each pointing at
// three slot numbers (1/13/25, 2/14/26, …, 12/24/36).
export const SLOT_LEGEND_GROUPS = BASE_SLOT_COLORS.map((c, i) => ({
  color: c.color,
  label: c.label,
  slotNumbers: [i + 1, i + 13, i + 25],
}));

// PRIMARY_SLOTS keeps the historical name — planner columns iterate over it.
// JOKER_SLOTS is kept exported (empty) for backwards compatibility.
export const PRIMARY_SLOTS = SLOTS;
export const JOKER_SLOTS = [];

export const STATUS_OPTIONS = [
  { value: "offer",     label: "Angebot" },
  { value: "planned",   label: "Geplant" },
  { value: "active",    label: "In Aufbau" },
  { value: "waiting",   label: "Warten auf" },
  { value: "paused",    label: "Pausiert" },
  { value: "billed",    label: "Abgerechnet" },
  { value: "live",      label: "Live" },
  { value: "completed", label: "Abgeschlossen" },
  { value: "archived",  label: "Archiviert" },
];

export const STATUS_VALUES = STATUS_OPTIONS.map((s) => s.value);
export const STATUS_RANK = Object.fromEntries(STATUS_OPTIONS.map((s, i) => [s.value, i]));

export const STATUS_LABEL = Object.fromEntries(STATUS_OPTIONS.map(s => [s.value, s.label]));

export const MONTHS_DE = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember",
];

export const WEEKDAYS_SHORT_DE = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

export function slotColor(n) {
  return SLOTS[n - 1]?.color ?? "#94a3b8";
}
